import { render } from "./addModuleGroup.vue?vue&type=template&id=562b3d5b"
import script from "./addModuleGroup.vue?vue&type=script&lang=js"
export * from "./addModuleGroup.vue?vue&type=script&lang=js"

import exportComponent from "E:\\zanbiya\\frontend\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__